import React from 'react';
import { navLinks, site } from '../data/site';
import { serviceGroups } from '../data/services';
export function SiteFooter() {
  return <footer className="border-t border-ink-600 bg-ink text-ivory" data-id="element-160" data-mp="3r8rfumw9e3ws">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-6 py-16 lg:grid-cols-[1.2fr_0.6fr_1fr] lg:px-10 lg:py-20" data-id="element-161" data-mp="3mgrc0jd2iqux">
        <div data-id="element-162" data-mp="3hhof5m78rqy1">
          <img src={site.logo} alt={site.name} width={2189} height={729} loading="lazy" decoding="async" className="h-12 w-auto invert" data-id="element-163" data-mp="3hi6ckm5n4b7j" />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-ivory/50" data-id="element-164" data-mp="33iovksyl628q">
            {site.tagline} Hardware sales, home installation, mounting, and design consulting for{' '}
            {site.serviceArea}.
          </p>
        </div>

        <nav aria-label="Footer" data-id="element-165" data-mp="11q8x1o7wvdt2">
          <h2 className="font-mono text-[10px] uppercase tracking-[0.22em] text-brass" data-id="element-166" data-mp="11p7mrlypyvce">Explore</h2>
          <ul className="mt-5 space-y-3" data-id="element-167" data-mp="wq4gxzax0l3d">
            {navLinks.map(link => <li key={link.href} data-id="element-168" data-mp="15pah5ka81im3">
                <a href={link.href} className="text-sm text-ivory/60 transition-colors hover:text-brass-light" data-id="element-169" data-mp="1apyfys4oz3qv">
                  {link.label}
                </a>
              </li>)}
            <li data-id="element-170" data-mp="10sk0ovui8l05">
              <a href="#contact" className="text-sm text-ivory/60 transition-colors hover:text-brass-light" data-id="element-171" data-mp="10s0qk1b3j0wo">
                Book a visit
              </a>
            </li>
          </ul>
        </nav>

        <div data-id="element-172" data-mp="1es35pfs0rg88">
          <h2 className="font-mono text-[10px] uppercase tracking-[0.22em] text-brass" data-id="element-173" data-mp="1esbh138hudhb">Services</h2>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-174" data-mp="1jpv0qinynign">
            {serviceGroups.map(group => <li key={group.id} data-id="element-175" data-mp="27f613z1efau9">
                <a href="#services" className="text-sm text-ivory/60 transition-colors hover:text-brass-light" data-id="element-176" data-mp="27e4ecxb0szwp">
                  {group.title}
                </a>
              </li>)}
          </ul>
          <address className="mt-8 not-italic text-sm text-ivory/60" data-id="element-177" data-mp="2h4w97q3dfv65">
            <a href={`tel:${site.phone.replace(/[^0-9]/g, '')}`} className="hover:text-brass-light" data-id="element-178" data-mp="2d1zkdhn8n2tr">
              {site.phone}
            </a>
            <br data-id="element-179" data-mp="282mwquojlrq4" />
            <a href={`mailto:${site.email}`} className="break-all hover:text-brass-light" data-id="element-180" data-mp="28594ovfci98v">
              {site.email}
            </a>
          </address>
        </div>
      </div>

      <div className="border-t border-ink-600" data-id="element-181" data-mp="1ybsahqbaqs4o">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-3 px-6 py-7 font-mono text-[10px] uppercase tracking-[0.2em] text-ivory/35 sm:flex-row sm:items-center sm:justify-between lg:px-10" data-id="element-182" data-mp="1tdz5v1pn666i">
          <p data-id="element-183" data-mp="1kdar24sfc1sk">
            © {new Date().getFullYear()} {site.name}
          </p>
          <p data-id="element-184" data-mp="1kfeteiaocsqq">Licensed · Insured · {site.hours}</p>
        </div>
      </div>
    </footer>;
}